import React, { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';

const currencies = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'NGN', symbol: '₦', name: 'Naira' },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan' },
  { code: 'VND', symbol: '₫', name: 'Vietnamese Dong' },
  { code: 'USDT', symbol: '₮', name: 'Tether' },
  { code: 'SDA', symbol: 'S', name: 'SDA Coin' },
  { code: 'DAN', symbol: 'D', name: 'DAN Token' },
];

const CurrencySelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(currencies[0]);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 rounded-lg bg-emerald-50 hover:bg-emerald-100 transition-colors"
      >
        <span className="font-semibold text-emerald-800">{selectedCurrency.symbol} {selectedCurrency.code}</span>
        <FiChevronDown className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-2xl border border-emerald-100 z-50 animate-slide-up">
          <div className="p-2">
            <div className="px-3 py-2 border-b">
              <p className="text-sm font-medium text-emerald-600">Select Currency</p>
            </div>
            <div className="max-h-60 overflow-y-auto">
              {currencies.map((currency) => (
                <button
                  key={currency.code}
                  onClick={() => {
                    setSelectedCurrency(currency);
                    setIsOpen(false);
                    // Here you would typically update global currency context
                  }}
                  className={`w-full flex items-center justify-between px-3 py-2 rounded-lg hover:bg-emerald-50 transition-colors ${
                    selectedCurrency.code === currency.code ? 'bg-emerald-100' : ''
                  }`}
                >
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 rounded-full bg-gradient-to-br from-emerald-500 to-amber-500 flex items-center justify-center">
                      <span className="text-white font-bold">{currency.symbol}</span>
                    </div>
                    <div className="text-left">
                      <p className="font-medium text-emerald-800">{currency.code}</p>
                      <p className="text-xs text-emerald-600">{currency.name}</p>
                    </div>
                  </div>
                  {selectedCurrency.code === currency.code && (
                    <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CurrencySelector;